import { useState } from 'react';
import TabsItem from '#components/navigation/tabs/tabsItem/TabsItem';
import TabPanel from '#components/navigation/tabs/tabPanel/TabPanel';
import TabScroll from '#components/navigation/tabs/tabsScroll/TabScroll';

const Tabs = ({ tabItems }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="tw-w-full">
      <TabScroll>
        {tabItems &&
          tabItems.map((item, index) => (
            <TabsItem
              id={index}
              key={`ti-${index}`}
              text={item.title}
              ariaSelected={activeIndex === index}
              handleOnClick={(e) => {
                e.preventDefault();
                setActiveIndex(index);
              }}
            />
          ))}
      </TabScroll>
      <div className="tw-pt-8">
        {tabItems &&
          tabItems.map((item, index) => (
            <TabPanel key={`tp-${index}`} ariaHidden={activeIndex !== index}>
              {item.component}
            </TabPanel>
          ))}
      </div>
    </div>
  );
};

export default Tabs;
